export default "__VITE_ASSET__CJBMemjz__"